export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

// Auth
export const ApiLogin = {
	method: 'post',
	url: '/api/Auth/Login'
}
export const ApiCheckAuth = {
	method: 'post',
	url: 'api/Auth/CheckAuth'
}
export const ApiRegister = {
	method: 'post',
	url: 'api/Auth/Register'
}

// Company
export const ApiCreateCompany = {
	method: 'post',
	url: 'api/Company/Create'
}
export const ApiUpdateCompany = {
	method: 'post',
	url: 'api/Company/Update'
}
export const ApiGetCompanyList = {
	method: 'post',
	url: 'api/Company/GetCompanyList'
}
export const ApiGetCompanyById = {
	method: 'post',
	url: 'api/Company/GetCompanyById'
}
export const ApiDeleteCompany = {
	method: 'post',
	url: 'api/Company/DeleteCompany'
}

// Contractor
export const ApiCreateContractor = {
	method: 'post',
	url: 'api/Contractor/Create'
}
export const ApiUpdateContractor = {
	method: 'post',
	url: 'api/Contractor/Update'
}
export const ApiGetContractorList = {
	method: 'post',
	url: 'api/Contractor/GetContractorList'
}
export const ApiGetContractorById = {
	method: 'post',
	url: 'api/Contractor/GetContractorById'
}
export const ApiDeleteContractor = {
	method: 'post',
	url: 'api/Contractor/DeleteContractor'
}
export const ApiGetContractorDropdown = {
	method: 'post',
	url: 'api/Contractor/Dropdown'
}

// User
export const ApiUpdateUser = {
	method: 'post',
	url: 'api/User/UpdateUser'
}
export const ApiGetUserList = {
	method: 'post',
	url: 'api/User/GetUserList'
}
export const ApiGetUserById = {
	method: 'post',
	url: 'api/User/GetUserById'
}
export const ApiDeleteUser = {
	method: 'post',
	url: 'api/User/DeleteUser'
}
export const ApiCheckIsAdmin = {
	method: 'post',
	url: 'api/User/CheckIsAdmin'
}
export const ApiGetCompanyAccessDropdown = {
	method: 'post',
	url: 'api/Company/Dropdown'
}

// User Company
export const ApiInsertUserCompany = {
	method: 'post',
	url: 'api/UserAccess/CreateUserCompany'
}
export const ApiInsertUserMenu = {
	method: 'post',
	url: 'api/UserAccess/CreateUserMenu'
}
export const ApiGetUserCompanyList = {
	method: 'post',
	url: 'api/UserAccess/GetUserCompanyList'
}
export const ApiDeleteUserCompany = {
	method: 'post',
	url: 'api/UserAccess/DeleteUserCompany'
}

// User Access
export const ApiGetUserAccessList = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessList'
}
export const ApiGetUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessByUserId'
}
export const ApiCheckUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/CheckAccess'
}

// Income
export const ApiGetIncomeList = {
	method: 'post',
	url: 'api/Income/GetIncomeList'
}

export const ApiPrintIncomeStatus = {
	method: 'post',
	url: 'api/Income/PrintStatus'
}

export const ApiGetSubconList = {
	method: 'post',
	url: 'api/SubCon/GetSubConList'
}

export const ApiPrintSubConStatus = {
	method: 'post',
	url: 'api/SubCon/PrintStatus'
}

export const ApiGetProductionBankList = {
	method: 'post',
	url: 'api/ProductionBank/GetProductionBankList'
}

export const ApiGetBankList = {
	method: 'post',
	url: 'api/ProductionBank/GetBankList'
}

// Project
export const ApiGetProjectList = {
	method: 'post',
	url: 'api/Project/GetProjectList'
}
export const ApiInsertProject = {
	method: 'post',
	url: 'api/Project/Create'
}
export const ApiUpdateProject = {
	method: 'post',
	url: 'api/Project/Update'
}
export const ApiDeleteProject = {
	method: 'post',
	url: 'api/Project/Delete'
}
export const ApiGetProjectById = {
	method: 'post',
	url: 'api/Project/GetProjectById'
}

// Payment
export const ApiCreatePayment = {
	method: 'post',
	url: 'api/Payment/Create'
}
export const ApiUpdatePayment = {
	method: 'post',
	url: 'api/Payment/Update'
}
export const ApiDeletePayment = {
	method: 'post',
	url: 'api/Payment/Delete'
}
export const ApiGetPaymentById = {
	method: 'post',
	url: 'api/Payment/GetPaymentById'
}
export const ApiGetPaymentList = {
	method: 'post',
	url: 'api/Payment/GetPaymentList'
}
export const ApiGetClientList = {
	method: 'post',
	url: 'api/Payment/GetClientName'
}

// Payment SubContractor
export const ApiCreatePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Create'
}
export const ApiUpdatePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Update'
}
export const ApiDeletePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Delete'
}
export const ApiGetPaymentByIdSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetPaymentById'
}
export const ApiGetPaymentListSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetPaymentList'
}
export const ApiGetClientListSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetClientName'
}







// Location
export const ApiInsertLocation = {
	method: 'post',
	url: '/api/Location/InsertLocation'
}
export const ApiUpdateLocation = {
	method: 'post',
	url: '/api/Location/UpdateLocation'
}
export const ApiDeleteLocation = {
	method: 'post',
	url: '/api/Location/DeleteLocation'
}
export const ApiGetLocation = {
	method: 'post',
	url: '/api/Location/GetLocation'
}
export const ApiGetLocationList = {
	method: 'post',
	url: '/api/Location/GetLocationList'
}

// Bank
export const ApiInsertBank = {
	method: 'post',
	url: '/api/Bank/InsertBank'
}
export const ApiUpdateBank = {
	method: 'post',
	url: '/api/Bank/UpdateBank'
}
export const ApiDeleteBank = {
	method: 'post',
	url: '/api/Bank/DeleteBank'
}
export const ApiGetBank = {
	method: 'post',
	url: '/api/Bank/GetBank'
}

// Vendor
export const ApiInsertVendor = {
	method: 'post',
	url: '/api/Vendor/InsertVendor'
}
export const ApiUpdateVendor = {
	method: 'post',
	url: '/api/Vendor/UpdateVendor'
}
export const ApiDeleteVendor = {
	method: 'post',
	url: '/api/Vendor/DeleteVendor'
}
export const ApiGetVendor = {
	method: 'post',
	url: '/api/Vendor/GetVendor'
}
export const ApiGetVendorList = {
	method: 'post',
	url: '/api/Vendor/GetVendorList'
}

// Customer
export const ApiInsertCustomer = {
	method: 'post',
	url: '/api/Customer/InsertCustomer'
}
export const ApiUpdateCustomer = {
	method: 'post',
	url: '/api/Customer/UpdateCustomer'
}
export const ApiDeleteCustomer = {
	method: 'post',
	url: '/api/Customer/DeleteCustomer'
}
export const ApiGetCustomer = {
	method: 'post',
	url: '/api/Customer/GetCustomer'
}
export const ApiGetCustomerList = {
	method: 'post',
	url: '/api/Customer/GetCustomerList'
}





// Kost
export const ApiInsertKost = {
	method: 'post',
	url: '/api/Kost/InsertKost'
}
export const ApiUpdateKost = {
	method: 'post',
	url: '/api/Kost/UpdateKost'
}
export const ApiDeleteKost = {
	method: 'post',
	url: '/api/Kost/DeleteKost'
}
export const ApiGetKostById = {
	method: 'post',
	url: '/api/Kost/GetKostById'
}
export const ApiGetKostList = {
	method: 'post',
	url: '/api/Kost/GetKostList'
}

// System Setting
export const ApiInsertSystemSetting = {
	method: 'post',
	url: '/api/SystemSetting/InsertSystemSetting'
}
export const ApiUpdateSystemSetting = {
	method: 'post',
	url: '/api/SystemSetting/UpdateSystemSetting'
}
export const ApiDeleteSystemSetting = {
	method: 'post',
	url: '/api/SystemSetting/DeleteSystemSetting'
}
export const ApiGetSystemSettingById = {
	method: 'post',
	url: '/api/SystemSetting/GetSystemSettingById'
}
export const ApiGetSystemSettingList = {
	method: 'post',
	url: '/api/SystemSetting/GetSystemSettingList'
}

// Room Type
export const ApiInsertRoomType = {
   method: 'post',
	url: '/api/RoomType/InsertRoomType'
}
export const ApiUpdateRoomType = {
   method: 'post',
	url: '/api/RoomType/UpdateRoomType'
}
export const ApiDeleteRoomType = {
   method: 'post',
	url: '/api/RoomType/DeleteRoomType'
}
export const ApiGetRoomTypeById = {
   method: 'post',
	url: '/api/RoomType/GetRoomTypeById'
}

// Room
export const ApiUpdateRoom = {
   method: 'post',
	url: '/api/Room/UpdateRoom'
}
export const ApiGetRoomByKostId = {
   method: 'post',
	url: '/api/Room/GetRoomByKostId'
}

// Tenant
export const ApiInsertTenant = {
	method: 'post',
	url: '/api/Tenant/InsertTenant'
}
export const ApiUploadPhotoId = {
	method: 'post',
	url: '/api/Tenant/UploadPhotoId'
}
export const ApiUploadPhotoFamilyCard = {
	method: 'post',
	url: '/api/Tenant/UploadPhotoFamilyCard'
}
export const ApiUploadPhotoSecondId = {
	method: 'post',
	url: '/api/Tenant/UploadPhotoSecondId'
}
export const ApiUpdateTenant = {
	method: 'post',
	url: '/api/Tenant/UpdateTenant'
}
export const ApiDeleteTenant = {
	method: 'post',
	url: '/api/Tenant/DeleteTenant'
}
export const ApiGetTenantById = {
	method: 'post',
	url: '/api/Tenant/GetTenantById'
}
export const ApiGetTenantList = {
	method: 'post',
	url: '/api/Tenant/GetTenantList'
}
export const ApiGenerateTenantId = {
	method: 'post',
	url: '/api/Tenant/GenerateTenantId'
}

// Booking
export const ApiInsertBooking = {
	method: 'post',
	url: '/api/Booking/InsertBooking'
}
export const ApiUpdateBooking = {
	method: 'post',
	url: '/api/Booking/UpdateBooking'
}
export const ApiGetBookingTenant = {
	method: 'post',
	url: '/api/Booking/GetBookingTenant'
}
export const ApiGetBookingRoom = {
	method: 'post',
	url: '/api/Booking/GetBookingRoom'
}
export const ApiGetBookingList = {
	method: 'post',
	url: '/api/Booking/GetBookingList'
}
export const ApiGetBookingById = {
	method: 'post',
	url: '/api/Booking/GetBookingById'
}
export const ApiGetPaymentHistory = {
	method: 'post',
	url: '/api/Booking/GetPaymentHistory'
}

// Payment
export const ApiGetPaymentTenant = {
	method: 'post',
	url: '/api/Payment/GetPaymentTenant'
}
export const ApiInsertPayment = {
	method: 'post',
	url: '/api/Payment/InsertPayment'
}
export const ApiGetBookingDetail = {
	method: 'post',
	url: '/api/Payment/GetBookingDetail'
}

// Kost Dashboard
export const ApiGetDashboardInfo = {
	method: 'post',
	url: '/api/Dashboard/GetDashboardInfo'
}

// Expense
export const ApiInsertExpense = {
	method: 'post',
	url: '/api/Expense/InsertExpense'
}
export const ApiDeleteExpense = {
	method: 'post',
	url: '/api/Expense/DeleteExpense'
}
export const ApiGetExpenseList = {
	method: 'post',
	url: '/api/Expense/GetExpenseList'
}

// Cashflow
export const ApiGetCashflow = {
	method: 'post',
	url: '/api/Cashflow/GetCashflow'
}